import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import PaymentsList from "./PaymentsList";
import PaymentCurrent from "./PaymentCurrent";

class Invoices extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            paymentsList: [],
        };
    }

    async componentDidMount() {
        await this.getPayments();
    }

    getPayments = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlSeguridad}/getVPagosWeb/${account.cuentaCodigo}`);
        if (data.cod === '1') {
            this.setState({
                paymentsList: data.V_pagos_WEB,
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Pagos'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Pagos</span>
                </h2>

                <div style={{width: '700px', margin: 'auto'}}>
                    <PaymentCurrent data={CuentaSelected.get()} />
                    <br />
                    <PaymentsList data={this.state.paymentsList} />
                </div>

            </div>
        );
    }
}

export default withRouter(Invoices)